import { observable, action, runInAction } from "mobx";
import { message } from "antd";

import RootStore from "app/RootStore";
import LawyerService from "contexts/lawyers/LawyerService";

export default class LawyerStore {
  @observable public loading = false;

  @observable public lawyerCount = 0;
  @observable public dataListLawyer: ResLawyer[] = [];
  @observable public dataListLawyerProfile: Record<
    number,
    ResLawyerProfile
  > = {};
  @observable
  public dataListPracticeArea: ResPracticeArea[] = [];

  private rootStore: RootStore;
  private lawyerService: LawyerService;

  constructor(rootStore: RootStore) {
    this.rootStore = rootStore;
    this.lawyerService = new LawyerService();
  }

  createLawyer(email: string) {
    return this.lawyerService.createLawyer(email);
  }

  @action
  async listLawyers(params: SearchParamsLawyer) {
    try {
      const res = await this.lawyerService.getLawyers({
        joinedStartDate: params.joinedStartDate,
        joinedEndDate: params.joinedEndDate,
        isRequestBased: params.isRequestBased,
        consultationStartDate: params.consultationStartDate,
        consultationEndDate: params.consultationEndDate,
        state: params.state,
        languages: params.languages,
        practiceAreas: params.practiceAreas,
      });
      runInAction(() => {
        this.lawyerCount = res.count;
        this.dataListLawyer = res.results;
      });
    } catch (err) {
      message.error(err.message || "There was a problem.");
    }
  }

  @action
  async listPracticeAreas() {
    try {
      const data = await this.lawyerService.getPracticeAreas();
      runInAction(() => {
        this.dataListPracticeArea = data;
      });
    } catch (err) {
      message.error(err.message || "There was a problem.");
    }
  }

  @action
  async listLawyerProfiles() {
    const lawyerIds = await this.lawyerService.getLawyerIds();
    const profiles = await Promise.all(
      lawyerIds.map((id) => this.lawyerService.getLawyerProfile(id)),
    );
    profiles.forEach((profile) => {
      this.dataListLawyerProfile[profile.lawyerId] = profile;
    });
  }
}
